export const gallerySectionConcreteRestoration =
{
    "title": "Explore Our Work",
    "columns": 3,
    "rowHeight": 1200,
    "pageSize": 9,
    "images": [
        {
            "src": "/assets/imgs/services/0008ConcreteRestoration/1.jpg",
            "rowSpan": 2,
            "colSpan": 1
        },
        {
            "src": "/assets/imgs/services/0008ConcreteRestoration/2.jpg",
            "rowSpan": 1,
            "colSpan": 2
        },
        {
            "src": "/assets/imgs/services/0008ConcreteRestoration/3.jpg",
            "rowSpan": 2,
            "colSpan": 2
        },
        {
            "src": "/assets/imgs/services/0008ConcreteRestoration/4.jpg",
            "rowSpan": 1,
            "colSpan": 1
        },
        {
            "src": "/assets/imgs/services/0008ConcreteRestoration/5.jpg",
            "rowSpan": 2,
            "colSpan": 1
        },
        {
            "src": "/assets/imgs/services/0008ConcreteRestoration/6.jpg",
            "rowSpan": 1,
            "colSpan": 2
        },
        {
            "src": "/assets/imgs/services/0008ConcreteRestoration/7.jpg",
            "rowSpan": 2,
            "colSpan": 2
        },
        {
            "src": "/assets/imgs/services/0008ConcreteRestoration/8.jpg",
            "rowSpan": 1,
            "colSpan": 1
        },
        {
            "src": "/assets/imgs/services/0008ConcreteRestoration/9.jpg",
            "rowSpan": 2,
            "colSpan": 1
        },
        {
            "src": "/assets/imgs/services/0008ConcreteRestoration/10.jpg",
            "rowSpan": 1,
            "colSpan": 2
        },
        {
            "src": "/assets/imgs/services/0008ConcreteRestoration/11.jpg",
            "rowSpan": 2,
            "colSpan": 2
        },
        {
            "src": "/assets/imgs/services/0008ConcreteRestoration/12.jpg",
            "rowSpan": 1,
            "colSpan": 1
        },
        {
            "src": "/assets/imgs/services/0008ConcreteRestoration/13.jpg",
            "rowSpan": 2,
            "colSpan": 1
        },
        {
            "src": "/assets/imgs/services/0008ConcreteRestoration/14.jpg",
            "rowSpan": 1,
            "colSpan": 2
        },
        {
            "src": "/assets/imgs/services/0008ConcreteRestoration/15.jpg",
            "rowSpan": 2,
            "colSpan": 2
        },
        {
            "src": "/assets/imgs/services/0008ConcreteRestoration/16.jpg",
            "rowSpan": 1,
            "colSpan": 1
        },
        {
            "src": "/assets/imgs/services/0008ConcreteRestoration/17.jpg",
            "rowSpan": 2,
            "colSpan": 1
        },
        {
            "src": "/assets/imgs/services/0008ConcreteRestoration/18.jpg",
            "rowSpan": 1,
            "colSpan": 2
        },
        {
            "src": "/assets/imgs/services/0008ConcreteRestoration/19.jpg",
            "rowSpan": 2,
            "colSpan": 2
        },
        {
            "src": "/assets/imgs/services/0008ConcreteRestoration/20.jpg",
            "rowSpan": 1,
            "colSpan": 1
        },
        {
            "src": "/assets/imgs/services/0008ConcreteRestoration/21.jpg",
            "rowSpan": 2,
            "colSpan": 1
        },
        {
            "src": "/assets/imgs/services/0008ConcreteRestoration/22.jpg",
            "rowSpan": 1,
            "colSpan": 2
        },
        {
            "src": "/assets/imgs/services/0008ConcreteRestoration/23.jpg",
            "rowSpan": 2,
            "colSpan": 2
        },
        {
            "src": "/assets/imgs/services/0008ConcreteRestoration/24.jpg",
            "rowSpan": 1,
            "colSpan": 1
        },
        {
            "src": "/assets/imgs/services/0008ConcreteRestoration/25.jpg",
            "rowSpan": 2,
            "colSpan": 1
        },
        {
            "src": "/assets/imgs/services/0008ConcreteRestoration/26.jpg",
            "rowSpan": 1,
            "colSpan": 2
        },
        {
            "src": "/assets/imgs/services/0008ConcreteRestoration/27.jpg",
            "rowSpan": 2,
            "colSpan": 2
        },
        {
            "src": "/assets/imgs/services/0008ConcreteRestoration/28.jpg",
            "rowSpan": 1,
            "colSpan": 1
        },
        {
            "src": "/assets/imgs/services/0008ConcreteRestoration/29.jpg",
            "rowSpan": 2,
            "colSpan": 1
        },
        {
            "src": "/assets/imgs/services/0008ConcreteRestoration/30.jpg",
            "rowSpan": 1,
            "colSpan": 2
        },
        {
            "src": "/assets/imgs/services/0008ConcreteRestoration/31.jpg",
            "rowSpan": 2,
            "colSpan": 2
        },
        {
            "src": "/assets/imgs/services/0008ConcreteRestoration/32.jpg",
            "rowSpan": 1,
            "colSpan": 1
        },
        {
            "src": "/assets/imgs/services/0008ConcreteRestoration/33.jpg",
            "rowSpan": 2,
            "colSpan": 1
        },
        {
            "src": "/assets/imgs/services/0008ConcreteRestoration/34.jpg",
            "rowSpan": 1,
            "colSpan": 2
        },
        {
            "src": "/assets/imgs/services/0008ConcreteRestoration/35.jpg",
            "rowSpan": 2,
            "colSpan": 2
        },
        {
            "src": "/assets/imgs/services/0008ConcreteRestoration/36.jpg",
            "rowSpan": 1,
            "colSpan": 1
        },
        {
            "src": "/assets/imgs/services/0008ConcreteRestoration/37.jpg",
            "rowSpan": 2,
            "colSpan": 1
        },
        {
            "src": "/assets/imgs/services/0008ConcreteRestoration/38.jpg",
            "rowSpan": 1,
            "colSpan": 2
        },
        {
            "src": "/assets/imgs/services/0008ConcreteRestoration/39.jpg",
            "rowSpan": 2,
            "colSpan": 2
        },
        {
            "src": "/assets/imgs/services/0008ConcreteRestoration/40.jpg",
            "rowSpan": 1,
            "colSpan": 1
        },
        {
            "src": "/assets/imgs/services/0008ConcreteRestoration/41.jpg",
            "rowSpan": 2,
            "colSpan": 1
        },
        {
            "src": "/assets/imgs/services/0008ConcreteRestoration/42.jpg",
            "rowSpan": 1,
            "colSpan": 2
        },
        {
            "src": "/assets/imgs/services/0008ConcreteRestoration/43.jpg",
            "rowSpan": 2,
            "colSpan": 2
        },
        {
            "src": "/assets/imgs/services/0008ConcreteRestoration/44.jpg",
            "rowSpan": 1,
            "colSpan": 1
        },
        {
            "src": "/assets/imgs/services/0008ConcreteRestoration/45.jpg",
            "rowSpan": 2,
            "colSpan": 1
        },
        {
            "src": "/assets/imgs/services/0008ConcreteRestoration/46.jpg",
            "rowSpan": 1,
            "colSpan": 2
        },
        {
            "src": "/assets/imgs/services/0008ConcreteRestoration/47.jpg",
            "rowSpan": 2,
            "colSpan": 2
        },
        {
            "src": "/assets/imgs/services/0008ConcreteRestoration/48.jpg",
            "rowSpan": 1,
            "colSpan": 1
        },
        {
            "src": "/assets/imgs/services/0008ConcreteRestoration/49.jpg",
            "rowSpan": 2,
            "colSpan": 1
        },
        {
            "src": "/assets/imgs/services/0008ConcreteRestoration/50.jpg",
            "rowSpan": 1,
            "colSpan": 2
        },
        {
            "src": "/assets/imgs/services/0008ConcreteRestoration/51.jpg",
            "rowSpan": 2,
            "colSpan": 2
        },
        {
            "src": "/assets/imgs/services/0008ConcreteRestoration/52.jpg",
            "rowSpan": 1,
            "colSpan": 1
        },
        {
            "src": "/assets/imgs/services/0008ConcreteRestoration/53.jpg",
            "rowSpan": 2,
            "colSpan": 1
        },
        {
            "src": "/assets/imgs/services/0008ConcreteRestoration/54.jpg",
            "rowSpan": 1,
            "colSpan": 2
        },
        {
            "src": "/assets/imgs/services/0008ConcreteRestoration/55.jpg",
            "rowSpan": 2,
            "colSpan": 2
        },
        {
            "src": "/assets/imgs/services/0008ConcreteRestoration/56.jpg",
            "rowSpan": 1,
            "colSpan": 1
        },
        {
            "src": "/assets/imgs/services/0008ConcreteRestoration/57.jpg",
            "rowSpan": 2,
            "colSpan": 1
        },
        {
            "src": "/assets/imgs/services/0008ConcreteRestoration/58.jpg",
            "rowSpan": 1,
            "colSpan": 2
        },
        {
            "src": "/assets/imgs/services/0008ConcreteRestoration/59.jpg",
            "rowSpan": 2,
            "colSpan": 2
        },
        {
            "src": "/assets/imgs/services/0008ConcreteRestoration/60.jpg",
            "rowSpan": 1,
            "colSpan": 1
        },
        {
            "src": "/assets/imgs/services/0008ConcreteRestoration/61.jpg",
            "rowSpan": 2,
            "colSpan": 1
        },
        {
            "src": "/assets/imgs/services/0008ConcreteRestoration/62.jpg",
            "rowSpan": 1,
            "colSpan": 2
        },
        {
            "src": "/assets/imgs/services/0008ConcreteRestoration/63.jpg",
            "rowSpan": 2,
            "colSpan": 2
        },
        {
            "src": "/assets/imgs/services/0008ConcreteRestoration/64.jpg",
            "rowSpan": 1,
            "colSpan": 1
        },
        {
            "src": "/assets/imgs/services/0008ConcreteRestoration/65.jpg",
            "rowSpan": 2,
            "colSpan": 1
        },
        {
            "src": "/assets/imgs/services/0008ConcreteRestoration/66.jpg",
            "rowSpan": 1,
            "colSpan": 2
        },
        {
            "src": "/assets/imgs/services/0008ConcreteRestoration/67.jpg",
            "rowSpan": 2,
            "colSpan": 2
        },
        {
            "src": "/assets/imgs/services/0008ConcreteRestoration/68.jpg",
            "rowSpan": 1,
            "colSpan": 1
        },
        {
            "src": "/assets/imgs/services/0008ConcreteRestoration/69.jpg",
            "rowSpan": 2,
            "colSpan": 1
        },
        {
            "src": "/assets/imgs/services/0008ConcreteRestoration/70.jpg",
            "rowSpan": 1,
            "colSpan": 2
        },
        {
            "src": "/assets/imgs/services/0008ConcreteRestoration/71.jpg",
            "rowSpan": 2,
            "colSpan": 2
        },
        {
            "src": "/assets/imgs/services/0008ConcreteRestoration/72.jpg",
            "rowSpan": 1,
            "colSpan": 1
        },
        {
            "src": "/assets/imgs/services/0008ConcreteRestoration/73.jpg",
            "rowSpan": 2,
            "colSpan": 1
        },
        {
            "src": "/assets/imgs/services/0008ConcreteRestoration/74.jpg",
            "rowSpan": 1,
            "colSpan": 2
        },
        {
            "src": "/assets/imgs/services/0008ConcreteRestoration/75.jpg",
            "rowSpan": 2,
            "colSpan": 2
        },
        {
            "src": "/assets/imgs/services/0008ConcreteRestoration/76.jpg",
            "rowSpan": 1,
            "colSpan": 1
        },
        {
            "src": "/assets/imgs/services/0008ConcreteRestoration/77.jpg",
            "rowSpan": 2,
            "colSpan": 1
        },
        {
            "src": "/assets/imgs/services/0008ConcreteRestoration/78.jpg",
            "rowSpan": 1,
            "colSpan": 2
        },
        {
            "src": "/assets/imgs/services/0008ConcreteRestoration/79.jpg",
            "rowSpan": 2,
            "colSpan": 2
        },
        {
            "src": "/assets/imgs/services/0008ConcreteRestoration/80.jpg",
            "rowSpan": 1,
            "colSpan": 1
        },
        {
            "src": "/assets/imgs/services/0008ConcreteRestoration/81.jpg",
            "rowSpan": 2,
            "colSpan": 1
        },
        {
            "src": "/assets/imgs/services/0008ConcreteRestoration/82.jpg",
            "rowSpan": 1,
            "colSpan": 2
        },
        {
            "src": "/assets/imgs/services/0008ConcreteRestoration/83.jpg",
            "rowSpan": 2,
            "colSpan": 2
        },
        {
            "src": "/assets/imgs/services/0008ConcreteRestoration/84.jpg",
            "rowSpan": 1,
            "colSpan": 1
        },
        {
            "src": "/assets/imgs/services/0008ConcreteRestoration/85.jpg",
            "rowSpan": 2,
            "colSpan": 1
        },
        {
            "src": "/assets/imgs/services/0008ConcreteRestoration/86.jpg",
            "rowSpan": 1,
            "colSpan": 2
        },
        {
            "src": "/assets/imgs/services/0008ConcreteRestoration/87.jpg",
            "rowSpan": 2,
            "colSpan": 2
        },
        {
            "src": "/assets/imgs/services/0008ConcreteRestoration/88.jpg",
            "rowSpan": 1,
            "colSpan": 1
        },
        {
            "src": "/assets/imgs/services/0008ConcreteRestoration/89.jpg",
            "rowSpan": 2,
            "colSpan": 1
        },
        {
            "src": "/assets/imgs/services/0008ConcreteRestoration/90.jpg",
            "rowSpan": 1,
            "colSpan": 2
        },
        {
            "src": "/assets/imgs/services/0008ConcreteRestoration/91.jpg",
            "rowSpan": 2,
            "colSpan": 2
        },
        {
            "src": "/assets/imgs/services/0008ConcreteRestoration/92.jpg",
            "rowSpan": 1,
            "colSpan": 1
        },
        {
            "src": "/assets/imgs/services/0008ConcreteRestoration/93.jpg",
            "rowSpan": 2,
            "colSpan": 1
        },
        {
            "src": "/assets/imgs/services/0008ConcreteRestoration/94.jpg",
            "rowSpan": 1,
            "colSpan": 2
        },
        {
            "src": "/assets/imgs/services/0008ConcreteRestoration/95.jpg",
            "rowSpan": 2,
            "colSpan": 2
        },
        {
            "src": "/assets/imgs/services/0008ConcreteRestoration/96.jpg",
            "rowSpan": 1,
            "colSpan": 1
        },
        {
            "src": "/assets/imgs/services/0008ConcreteRestoration/97.jpg",
            "rowSpan": 2,
            "colSpan": 1
        },
        {
            "src": "/assets/imgs/services/0008ConcreteRestoration/98.jpg",
            "rowSpan": 1,
            "colSpan": 2
        },
        {
            "src": "/assets/imgs/services/0008ConcreteRestoration/99.jpg",
            "rowSpan": 2,
            "colSpan": 2
        },
        {
            "src": "/assets/imgs/services/0008ConcreteRestoration/100.jpg",
            "rowSpan": 1,
            "colSpan": 1
        },
        {
            "src": "/assets/imgs/services/0008ConcreteRestoration/101.jpg",
            "rowSpan": 2,
            "colSpan": 1
        },
        {
            "src": "/assets/imgs/services/0008ConcreteRestoration/102.jpg",
            "rowSpan": 1,
            "colSpan": 2
        },
        {
            "src": "/assets/imgs/services/0008ConcreteRestoration/103.jpg",
            "rowSpan": 2,
            "colSpan": 2
        },
        {
            "src": "/assets/imgs/services/0008ConcreteRestoration/104.jpg",
            "rowSpan": 1,
            "colSpan": 1
        },
        {
            "src": "/assets/imgs/services/0008ConcreteRestoration/105.jpg",
            "rowSpan": 2,
            "colSpan": 1
        },
        {
            "src": "/assets/imgs/services/0008ConcreteRestoration/106.jpg",
            "rowSpan": 1,
            "colSpan": 2
        },
        {
            "src": "/assets/imgs/services/0008ConcreteRestoration/107.jpg",
            "rowSpan": 2,
            "colSpan": 2
        },
        {
            "src": "/assets/imgs/services/0008ConcreteRestoration/108.jpg",
            "rowSpan": 1,
            "colSpan": 1
        },
        {
            "src": "/assets/imgs/services/0008ConcreteRestoration/109.jpg",
            "rowSpan": 2,
            "colSpan": 1
        },
        {
            "src": "/assets/imgs/services/0008ConcreteRestoration/110.jpg",
            "rowSpan": 1,
            "colSpan": 2
        },
        {
            "src": "/assets/imgs/services/0008ConcreteRestoration/111.jpg",
            "rowSpan": 2,
            "colSpan": 2
        },
        {
            "src": "/assets/imgs/services/0008ConcreteRestoration/112.jpg",
            "rowSpan": 1,
            "colSpan": 1
        },
        {
            "src": "/assets/imgs/services/0008ConcreteRestoration/113.jpg",
            "rowSpan": 2,
            "colSpan": 1
        },
        {
            "src": "/assets/imgs/services/0008ConcreteRestoration/114.jpg",
            "rowSpan": 1,
            "colSpan": 2
        },
        {
            "src": "/assets/imgs/services/0008ConcreteRestoration/115.jpg",
            "rowSpan": 2,
            "colSpan": 2
        },
        {
            "src": "/assets/imgs/services/0008ConcreteRestoration/116.jpg",
            "rowSpan": 1,
            "colSpan": 1
        }
    ]
}